import React from "react";
import { Box } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import PostDetailsCard from "./Utilities/PostDetailsCard";
import CommentThread from "./Utilities/CommentThread";
import PostPerformance from "./Utilities/PostPerformance";
import BasicButton from "components/v2/common/BasicButton";
import NorthEastIcon from "@mui/icons-material/NorthEast";

export default function SocialPostsDetails() {
  return (
    <Box sx={{ backgroundColor: "#EDEDE4" }}>
      <Box sx={styles.root}>
        <Box sx={styles.container}>
          <RouterLink to={"/social-posts"} className="tms-no-underline">
            <Box sx={styles.backLink}>
              <Box>
                <ArrowBackIosNewIcon sx={styles.arrowBack} />
              </Box>
              <Box mt={"1px"}> Back to Social Posts</Box>
            </Box>
          </RouterLink>

          <Box sx={styles.bodyWrapper}>
            <Box sx={{ flex: 1 }}>
              <PostDetailsCard />
              <CommentThread />
            </Box>

            <Box
              sx={{
                flex: 1,
                maxWidth: "300px",
              }}
            >
              <PostPerformance />
              <Box mt={2}>
                <BasicButton
                  endIcon={<NorthEastIcon style={{ fontSize: "16px" }} />}
                  style={{
                    borderRadius: "10px",
                    height: "48px",
                    fontSize: "14px",
                    fontFamily: "FustatMedium",
                  }}
                  label={"View on Instagram"}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

const styles = {
  root: {
    pt: 12,
    minHeight: "100vh",
    pb: 10,
  },
  container: {
    px: { xs: 2, sm: 4, md: 6 },
    width: "100%",
    maxWidth: "1440px",
    position: "relative",
    mx: "auto",
  },
  bodyWrapper: {
    display: "flex",
    gap: "24px",
    alignItems: "flex-start",
    position: "relative",
    mt: 2,
  },
  arrowBack: {
    color: "#003300",
    marginRight: "8px",
    borderRadius: "0px",
    fontSize: "14px",
    position: "absolute",
    left: "0",
    top: "3px",
  },
  backLink: {
    color: "#302E2A",
    position: "relative",
    fontFamily: "FustatBold",
    fontSize: "14px",
    display: "flex",
    alignItems: "flex-end",
    gap: "20px",
  },
};
